// @ts-nocheck
// import dama from "/modules/dama.js";
// import apiDrupal from "./api.js";
// const dm = new dama();

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { datalayers } from "../config/datalayers";

// import gsap from "gsap";
import AOS from 'aos';
import 'aos/dist/aos.css';
import SplitText from "../components/splitText";

declare global {
    interface Window {
        animations: any;
    }
}

// const api = new apiDrupal();
export const page = async () => {
    /* ON LOAD */
    
    datalayers();

    modalBeers()

    const btnagedateYes:HTMLElement = document.querySelector('.age_gate_yes')

	btnagedateYes && btnagedateYes.addEventListener('click', e =>{
		e.preventDefault()
		validateAOS()
        const pathUser = window.location.pathname, 
            substr = pathUser.substr(0,5);
        if(substr != '/user'){
            // location.reload();
        }
	})
    validateAOS()
	
	function validateAOS(){
		setTimeout( () => {
            if( document.querySelector('#agv2') ) {
				setTimeout( () => {
					if( !document.querySelector('#agv2') ){
                        AOS.init({
                            once: true
                        });
                    }
				}, 300 )
			} else {
                AOS.init({
                    once: true
                });
			}
		}, 300)
	}
    

    let btnMenuMobile = document.getElementById("btnMenuMobile");
    let headerMxMichelob = document.getElementById("headerMxMichelob");

    btnMenuMobile.addEventListener("click", () => {
        headerMxMichelob.classList.toggle("header-active-mobile");
    });

    if(document.querySelector('.mxmhboxRecipes__content--title')) new SplitText(".mxmhboxRecipes__content--title")
}

function modalBeers(){
    const boxVideo:NodeListOf<HTMLElement> = document.querySelectorAll('.modalVideo'),
    modalVideo = document.querySelector('.popup'),
    closeModal = document.querySelectorAll('.closePopup');

    boxVideo.length > 0 && Array.from(boxVideo).map(iframe => {
        iframe.addEventListener('click', e => {
            e.preventDefault()
            const dataVideo = iframe.dataset.video,
                newSrc = `https://player.vimeo.com/video/${dataVideo}?enablejsapi=1;rel=0&amp;autoplay=1`,
                iframeVideo: HTMLVideoElement = document.querySelector('.modalHome .videoYT iframe');

            modalVideo.classList.add('active')
            
            if (iframeVideo && newSrc) iframeVideo.src = newSrc;

        })
    })
    closeModal.length > 0 && Array.from(closeModal).map(closeM => {
        closeM.addEventListener('click', e => {
            e.preventDefault()
            const parentModal = closeM.closest(".popup");
            parentModal.classList.remove('active')
            // toggleVideo('hide')
        })
    })
}
function toggleVideo(state: string) {
    // if state == 'hide', hide. Else: show video
    var div = document.getElementById("videoYT");
    var iframe = div.getElementsByTagName("iframe")[0].contentWindow;
    var iframe1 = div.getElementsByTagName("iframe")
    //div.style.display = state == 'hide' ? 'none' : '';
    // const func = state == 'hide' ? 'pauseVideo' : 'playVideo';
    if (state == 'hide') {
        
        iframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
    if (state == 'show') {
        iframe.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
}